import { pick } from "es-toolkit";

import {
  EProgrammingGanttViewMode,
  IProgrammingGanttData,
  IProgrammingGanttRow,
} from "@/components/programming-gantt/programming-gantt";
import {
  ISelectedSchedule,
  IProgrammingDeviceRow,
  IProgrammingDeviceSchedule,
} from "@/components/programming-gantt/programming-gantt.type";
import { TSectionPlanning } from "@/data/api/kili/sites/types/planning.type";
import { ETimeUnit } from "@/utils/time";

export const PilotingWizardStateInjectKey = Symbol("PilotingWizardState");

export enum EProgrammingDurationMode {
  DURATION = "duration",
  DATE_RANGE = "date-range",
}

export function getTrackingDurationMode(mode?: EProgrammingDurationMode) {
  if (mode === EProgrammingDurationMode.DATE_RANGE) {
    return "period";
  }

  return mode;
}

export interface IPilotingWizardState {
  selection: Array<IProgrammingGanttRow>;
  data: IProgrammingGanttData<IProgrammingDeviceRow, IProgrammingDeviceSchedule>;
  plannings: TSectionPlanning[];
  siteId: number;
  isPlanningsLoading: boolean;
  formMode: "create" | "edit";
  maybeSelectedSchedule?: ISelectedSchedule;
  selectedViewMode?: EProgrammingGanttViewMode;
}

// Only these three values are available, we type here for defineModel bellow
export const EDurationUnit = pick(ETimeUnit, ["HOUR", "DAY", "WEEK", "MONTH"]);
export type TEDurationUnit = keyof typeof EDurationUnit;
